import React from 'react'

import Paper from "@mui/material/Paper";


function Docs(props) {
  return (
    <div className="col-md-3">
    <section className="container">
      <Paper
        component="form"
        sx={{ p: "4px 4px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#F3F3F3", height: "200px" }}
        fullWidth
        elevation={0}
      >
        <img src="https://via.placeholder.com/150" alt="Thumbnail" style={{ height: '100%', maxWidth: '100%' }} />
        {/* <img src={props.resource.thumbnail} alt={`${props.resource.title} thumbnail`} style={{ height: '100%', maxWidth: '100%' }} /> */}
      </Paper>
    </section>
  </div>
  )
}

export default Docs